
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { TourExhibitItem } from './TourExhibitItem';
import type { TourDetailExhibit } from '@/hooks/useTourDetail';

interface TourExhibitsListProps {
  tourId: string;
  exhibits: TourDetailExhibit[];
}

export const TourExhibitsList: React.FC<TourExhibitsListProps> = ({ 
  tourId, 
  exhibits
}) => {
  const { language } = useLanguage();
  
  return (
    <div className="bg-white p-6 rounded-xl shadow-sm mb-8">
      {exhibits.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          {language === 'en' ? 'No exhibits found for this tour.' : 'לא נמצאו תערוכות לסיור זה.'}
        </div>
      ) : (
        <div className="space-y-4">
          {exhibits.map((exhibit, index) => (
            <TourExhibitItem
              key={exhibit.id}
              id={exhibit.id}
              numberCode={exhibit.numberCode}
              titleEn={exhibit.titleEn}
              titleHe={exhibit.titleHe}
              image={exhibit.image}
              location={exhibit.location}
              tourId={tourId}
            />
          ))}
        </div>
      )}
    </div>
  );
};
